import React, { FC } from 'react';
import { CloseRequiredFormProps } from './CloseRequiredFormProps';
import useTranslation from '../../../hooks/useTranslation';
import ProjectNameInput from '../../ProjectTab/ProjectNameInput';
import ProjectDatesFields from '../../ProjectTab/ProjectDatesFields';
import SiteInfoSelects from '../../SiteTab/SiteInfoFields/SiteInfoSelects';
import LocationInfoCountrySelect from '../../SiteTab/LocationInfoCountrySelect';
import ProjectConfidentialButton from '../../ProjectTab/ProjectConfidentialButton';
import Text from '@ingka/text';
import BUInput from '../../SiteTab/BUInputs';
import ProjectCountryResponsible from '../../ProjectCountryResponsible';

const CloseRequiredForm: FC<CloseRequiredFormProps> = ({
  countries,
  isConfidentialAllowed,
  onCountryChange,
  BUList,
  usersList,
  onBUChange,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectInformation')}
      </Text>
      <ProjectNameInput />
      <ProjectDatesFields openingDate closeLabel />
      <LocationInfoCountrySelect
        countries={countries}
        onCountryChange={onCountryChange}
      />
      <BUInput BuList={BUList} onBUChange={onBUChange} required />
      <SiteInfoSelects unitType transactionType />
      <ProjectCountryResponsible usersList={usersList} required={true} />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
    </>
  );
};

export default CloseRequiredForm;
